export default {
    hello: '你好， 世界',
    locale: {
        en: 'English',
        zh: '中文'
    },
    topNav: {
        userCenter: '用户中心',
        msgCenter: '消息中心',
        login: '登录',
        logout: '退出'
    },
    login: {
        username: '用户名',
        usernamePlaceholder: '登录用户',
        password: '密码',
        passwordPlaceholder: '登录密码',
        login: '登录'
    },
    link: {
        home: '首页'
    }
};


// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js